import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Presentation } from "lucide-react";
import React from "react";

interface IProps {
  title: string;
  subTitle: string;
  date: string;
  color: string;
  endContent?: React.ReactNode;
  image?: string;
}

export const EventStrip = ({ title, subTitle, date, color, endContent, image }: IProps) => {
  return (
    <div
      className="w-full flex items-center justify-between bg-muted px-3 py-2 rounded-xs"
      style={{ borderLeft: `4px solid ${color}` }}
    >
      <div className="flex gap-2 items-center">
        <Avatar>
          <AvatarImage src={image ?? undefined} />
          <AvatarFallback>
            <Presentation />
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="text-sm font-semibold">{title}</p>
          <p className="text-sm text-gray-500 capitalize">{subTitle}</p>
        </div>
      </div>
      {date && <p className="text-sm text-gray-500">{date}</p>}
      {endContent && endContent}
    </div>
  );
};
